import Layout from 'components/Layout';
import {
  IMarkDownContainer,
  MarkDownContainer as MarkDownSection,
} from 'containers/MarkdownContainer';
import { graphql } from 'gatsby';
import React from 'react';
import { IContentWithImage } from 'utils/types';

import { SEO } from '../components/SEO';

const components: {
  MarkDownSection: React.FC<IMarkDownContainer>;
} = {
  MarkDownSection,
};

type Props = {
  data: {
    content: {
      title: string;
      sections: {
        componentName: string;
        headline: string;
        description?: { description: string };
        slug: string;
        title?: string;
        listOfContentWithImages?: IContentWithImage[];
        markdownField?: {
          childMarkdownRemark?: {
            html: string;
          };
        };
      }[];
    };
  };
};

export const Head = () => <SEO />;

export const privacyPolicyPage = (props: Props) => {
  const { data } = props;
  const { content } = data;
  const { sections } = content;

  return (
    <Layout>
      {sections.map((section, i: number) => {
        // @ts-ignore
        if (components[section.componentName]) {
          return React.createElement(
            // @ts-ignore
            components[section.componentName],
            {
              content: section,
              key: `${section.componentName}-${i}`, // handles the case for duplicate section keys
            },
          );
        }
      })}
    </Layout>
  );
};

export default privacyPolicyPage;

export const data = graphql`
  query {
    content: contentfulPage(pageId: { eq: "EHSPrivacyPolicy" }) {
      title
      sections {
        headline
        componentName
        slug
        backgroundColor
        description {
          description
        }
        markdownField {
          childMarkdownRemark {
            html
          }
        }
      }
    }
  }
`;
